import { LDProvider } from 'launchdarkly-react-client-sdk';
import type { ReactNode } from 'react';
import packageJson from '../../../../package.json';
import { settings } from '../../../../settings';
import { useUser } from '../context/UserContext';

export const LDProviderWrapper = ({
  user,
  children,
}: {
  user: any;
  children: ReactNode;
}) => {
  const { activeOrganization } = useUser();

  return (
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    <LDProvider
      clientSideID={settings.LDKEY}
      deferInitialization
      user={{
        key: user.email,
        email: user.email,
        custom: {
          org: activeOrganization?.organization_name,
          organizationName: activeOrganization?.organization_name,
          organizationId: activeOrganization?.id,
          organizationSlug: activeOrganization?.slug_name,
          platformType: 'desktop-app',
          versionNumber: packageJson.version,
        },
      }}
    >
      {children}
    </LDProvider>
  );
};
